export default __webpack_public_path__ + "static/media/calendarDown.b3e8292a.svg";